import * as Y from 'yjs';

import { WidgetType } from 'shared/widgets/utils';

import { manifestLocales } from './manifest.locales';
import { createNewFillInTheBlanksQuestionAnswerData } from '@/contentObjects/FillInTheBlanksQuestionAnswer/create';
import { InitializePropsOptions, ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';
import { Feedbacks } from '@/utils/feedback.utils';
import { htmlToXmlFragment } from '@/utils/tiptap';
import { getEvaluationProps } from '@/widgets/consts/getEvaluationProps';
import { createQuestionWidgetChildren } from '@/widgets/utils/createQuestionWidgetChildren';

export function createNewFillInTheBlanksQuestionData(options: InitializePropsOptions): ManifestInitializedProps {
  const { isPlenaryLesson, locale } = options;

  const { answerPlaceholder, initialHeadlineText } = manifestLocales.fillInTheBlanksQuestion;
  const id = genRandId();
  const labelFragment = htmlToXmlFragment(`<h2><span>${initialHeadlineText[locale]}</span></h2>`);
  const answerFragment = htmlToXmlFragment('<p></p>');
  const hintFragment = htmlToXmlFragment('<p></p>');

  const widgetEvaluationProps = Object.entries(getEvaluationProps(isPlenaryLesson));

  const [questionAnswerData] = createNewFillInTheBlanksQuestionAnswerData();
  const { childrenArray, horizontalFlexSectionData, verticalFlexSectionData } = createQuestionWidgetChildren(
    questionAnswerData.id,
    options?.width
  );

  return [
    {
      id,
      contentObjectData: new Y.Map([
        ['id', id],
        ['type', WidgetType.FillInTheBlanksQuestion],
        ['children', childrenArray],
        ['labelFragment', labelFragment],
        ['answerFragment', answerFragment],
        ['hintFragment', hintFragment],
        ['answerPlaceholder', answerPlaceholder[locale]],
        ['feedback', Feedbacks.Check],
        ['wordBankOptions', new Y.Array()], //[{id: xxx, value: xxx}]
        ['saveAnswers', true],
        ...widgetEvaluationProps,
        ['questionAnswerId', questionAnswerData.id]
      ]),
      sensitiveData: new Y.Map([
        ['correctOptions', new Y.Map()] //id (fillInTheBlanksId) -> id (optionId)
      ])
    },
    verticalFlexSectionData,
    horizontalFlexSectionData,
    questionAnswerData
  ];
}

/**
 * in the player:
 *
 * each word in the bank has an optionId and a value
 *
 * each input has an fillInTheBlanksId
 *
 * when a word is dragged into an input we can take the fillInTheBlanksId and check server side (sensitive data) which optionId is connected to it, then check if it fits the one that was dragged.
 *
 *
 * in the studio:
 *
 * when rendering the inputs we can grab the connected value directly from sensitive data here without checking server side
 *
 */
